import { AxiosInstance } from 'axios';
import SpotBillingRepository from '@/repository/spot-billing/SpotBillingRepository';

export default (axios: AxiosInstance) => {
  const spotBillingRepository = SpotBillingRepository(axios);
  return {
    spotBillingRepository: spotBillingRepository(),
  };
};
